<div class="tile-container">
  <div class="card" [ngClass]="deletingMask ? 'card deleting-mask' : 'card'">
    <div class="card-title">
      <div class="card-title-infos">
        <span class="span-title" appTooltip [tooltipItems]="tooltipContent">
          {{ mask.name }}
        </span>
        <div *ngIf="mask.hasExpiredMedia === true">
          <mat-icon 
            appTooltip [tooltipText]="'mask_list.tile.expired_media' | translate"
            *ngIf="mask.maskScheduleStatus === maskScheduleStatusEnums.NotPublished || mask.maskScheduleStatus === maskScheduleStatusEnums.BroadcastEnded" 
            >
            sd_card_alert
          </mat-icon>
          <mat-icon 
            appTooltip [tooltipText]="'mask_list.tile.expired_media_soon' | translate"
            *ngIf="mask.maskScheduleStatus === maskScheduleStatusEnums.InBroadcast || mask.maskScheduleStatus === maskScheduleStatusEnums.NextBroadcast"  
          >
            sd_card_alert
          </mat-icon>
        </div>
      </div>
      <div class="card-title-menu">
        <div *ngIf="!deletingMask; else deleting">
          <app-contextual-menu
            menuType="mask"
            [hidePreview]="mask.maskScheduleStatus === maskScheduleStatusEnums.NotPublished"
            [hideEdit]="mask.maskScheduleStatus === maskScheduleStatusEnums.BroadcastEnded"
            (outputEdit)="editMask()"
            (outputPreview)="previewMask()"
            (outputDuplicate)="duplicateMask()"
            (outputDelete)="requestMaskDeletion()"
            [canDelete]="canDelete"
          ></app-contextual-menu>
        </div>
        <ng-template #deleting>
          <button class="deletion-spinner-btn" mat-icon-button disabled>
            <mat-icon>
              <mat-spinner diameter="22"></mat-spinner>
            </mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
    <div [class]="'card-divider-' + mask.maskScheduleStatus"></div>
    <div class="card-body">
      <div class="card-body-schedule" appTooltip [tooltipText]="detailedSchedule">
        <mat-icon>event</mat-icon>
        <span>{{ schedule }}</span>
      </div>
      <div class="card-footer">
        <div class="card-footer-duration">
          <mat-icon>schedule</mat-icon>
          <span>{{ mask.totalDuration }} s</span>
        </div>
        <div
          *ngIf="!mask.isChannelMask"
          class="card-footer-audience"
          appTooltip
          [tooltipItems]="audiences"
          [tooltipUseBulletPoints]="true"
          [tooltipTitle]="'mask_list.tile.audience_title' | translate"
        >
          <span>{{ audiences.length }}</span>
          <mat-icon>wifi_tethering</mat-icon>
        </div>
        <div class="card-footer-slide">
          <span>{{ mask.slidesCount }}</span>
          <mat-icon>dvr</mat-icon>
        </div>
        <div class="card-footer-format">
          <mat-icon 
            appTooltip 
            [tooltipText]="(mask.screenFormatId - 1 | localizedEnum: screenFormatEnum) ?? ''" 
            [ngStyle]="{'transform': (mask.screenFormatId === screenFormatEnum.Landscape_16_9 || mask.screenFormatId === screenFormatEnum.Stretch_Vertical) ? 'rotate(90deg)' : 'rotate(0deg)'}"
          >
            <ng-container *ngIf="mask.screenFormatId === screenFormatEnum.Landscape_16_9" >smartphone</ng-container>
            <ng-container *ngIf="mask.screenFormatId === screenFormatEnum.Portrait_9_16">smartphone</ng-container>
            <ng-container *ngIf="mask.screenFormatId === screenFormatEnum.Stretch_Vertical">smart_screen</ng-container>
            <ng-container *ngIf="mask.screenFormatId === screenFormatEnum.Stretch_Horizontal">smart_screen</ng-container>
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
